export const googleClientId =
  '325718099939-79h76s80oiuhtsll5t51vpg2jb9shg8c.apps.googleusercontent.com';
